import { Box } from '@mui/material';
import React, { useState } from 'react';
import { translateTextArea } from '../../TranslateWidget';
import { useTextLineCount } from '../../hooks/useTextLineCount';

interface TextBoxproptype {
  className?: string;
  name?: string;
  Value: string | null;
  handlechange?: (value: string) => void;
  maxLength?: number;
  placeholder?: string;
  height?: string;
  rows?: number;
  disabled?: boolean;
  Required?: boolean;
  placeholderBackgroundColor?: string;
  style?: React.CSSProperties;
  disableAutoGrow?: boolean;
}

const CommentTextbox: React.FC<TextBoxproptype> = (props) => {
  const {
    rows,
    height,
    placeholder,
    maxLength,
    className,
    style,
    name,
    Value,
    disabled,
    handlechange,
    Required,
    placeholderBackgroundColor,
    disableAutoGrow,
  } = props;

  const [isFocused, setIsFocused] = useState(false);
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);
  const lineCount = useTextLineCount(textareaRef, Value ?? '');

  const getBackgroundColor = (pBgColor?: string) => {
    if (!isFocused) {
      if (Value !== null && Value?.length !== 0 && pBgColor) {
        return pBgColor;
      }
      return 'white';
    }
    if (Value !== null && pBgColor) {
      return pBgColor;
    } else {
      return 'white';
    }
  };
  const getRowsCount = () => {
    if (disableAutoGrow) {
      return rows;
    }

    return lineCount === 1 ? rows : lineCount;
  };
  return (
    <Box style={{ position: 'relative', width: '100%', marginTop: '8px' }}>
      {placeholder && (
        <label
          style={{
            position: 'absolute',
            top: isFocused || Value ? '-8px' : '12px',
            left: '10px',
            fontSize: isFocused || Value ? '12px' : '14px',
            color: isFocused ? '#00C6B8' : '#97A6A5',
            transition: 'border-color 0.2s ease-out',
            pointerEvents: 'none',
            zIndex: 1,
            backgroundColor:
              disabled && !Value
                ? 'transparent'
                : getBackgroundColor(placeholderBackgroundColor),
            padding: '0 4px',
            fontFamily: 'Lato-Regular',
          }}
        >
          {`${placeholder}${Required ? '*' : ''} `}
        </label>
      )}
      <textarea
        id={name}
        ref={textareaRef}
        className={`textarea translate ${className}`}
        rows={getRowsCount()}
        maxLength={maxLength}
        disabled={disabled}
        value={Value ?? ''}
        onChange={(event) => {
          if (handlechange !== undefined) {
            handlechange(event.target.value.trimStart());
            if (name) {
              translateTextArea(name || 'comment');
            }
          }
        }}
        required={Required}
        onFocus={(e) => {
          if (!disabled) {
            e.target.style.borderColor = '#00C6B8';
          }
          setIsFocused(true);
        }}
        onBlur={(e) => {
          if (!disabled) {
            e.target.style.borderColor = '#ccc';
          }
          setIsFocused(false);
        }}
        style={{
          width: '100%',
          fontFamily: 'Lato-Regular',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '19px',
          height: height ?? 'auto',
          minHeight: height,
          padding: '12px 16px',
          border: disabled ? '1px solid #D0D0D0' : '1px solid #ccc',
          borderRadius: '4px',
          transition: 'border-color 0.3s ease-out',
          resize: 'none',
          outline: 'none',
          overflow: disableAutoGrow ? 'auto' : 'hidden',
          backgroundColor: disabled ? '#F2F2F2' : 'white',
          color: disabled ? '#97A6A5' : 'inherit',
          cursor: disabled ? 'not-allowed' : 'text',
          ...style,
        }}
      />
    </Box>
  );
};

export default CommentTextbox;
